export default __webpack_public_path__ + "static/media/1.332b4441.jpg";